// src/i18n/CustomBackend.js
import { instance2 } from '@/controller/base.js';

class CustomBackend {
    constructor(services, backendOptions = {}) {
        this.init(services, backendOptions);
    }

    init(services, backendOptions) {
        this.services = services;
        this.options = backendOptions;
    }

    async read(language, namespace, callback) {
        try {
            console.log('Loading translations for:', language, namespace);
            const response = await instance2.get(`/api/v1/translation`, {
                params: {
                    lang: language,
                    namespace: namespace,
                },
            });

            console.log('Translation response:', response.data.data);
            callback(null, response.data.data);
        } catch (error) {
            console.error('Error loading translations:', error);
            callback(error, null);
        }
    }
}

CustomBackend.type = 'backend';

export default CustomBackend;
